module.exports = __webpack_public_path__ + "static/img/img03@2x.0145b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/instructions/img03@2x.png
// module id = sszm
// module chunks = 174